import(/* webpackMode: "eager", webpackExports: ["PublicContentProvider"] */ "/vercel/path0/apps/platform/lib/public-content-provider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/clients/autozonasaltas/site/renderer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/clients/car_keepers_club/site/renderer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/clients/locusly_blog/site/renderer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/clients/madeira_mobile_mechanic/site/renderer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/clients/wedding_invitation/site/renderer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/clients/wedding_invitation/src/assets/icons/ChatGPT Image 3_05_2026, 23_56_38.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/clients/wedding_invitation/src/assets/icons/ChatGPT Image 4_05_2026, 00_01_37.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/clients/wedding_invitation/src/assets/icons/ChatGPT Image 4_05_2026, 00_04_07.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/clients/wedding_invitation/src/assets/icons/ChatGPT Image 4_05_2026, 00_04_17.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/clients/wedding_invitation/src/assets/icons/ChatGPT Image 4_05_2026, 01_32_36 (1).png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/clients/wedding_invitation/src/assets/icons/ChatGPT Image 4_05_2026, 01_32_37 (2).png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/clients/wedding_invitation/src/assets/Northwest-Madeira-7-scaled-1.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/clients/wedding_invitation/src/assets/WhatsApp Image 2026-05-03 at 21.44.29 (1).jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/clients/wedding_invitation/src/assets/WhatsApp Image 2026-05-03 at 21.44.29.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/clients/wedding_invitation/src/assets/WhatsApp Image 2026-05-03 at 21.44.41.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["EditModeProvider","useEditMode"] */ "/vercel/path0/packages/client-runtime/src/edit-mode/context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EditableImage"] */ "/vercel/path0/packages/client-runtime/src/edit-mode/editable-image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EditableList"] */ "/vercel/path0/packages/client-runtime/src/edit-mode/editable-list.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EditableText"] */ "/vercel/path0/packages/client-runtime/src/edit-mode/editable-text.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EditableVideo"] */ "/vercel/path0/packages/client-runtime/src/edit-mode/editable-video.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/client-runtime/src/features.ts");
